module.exports = __webpack_public_path__ + "img/safeheron.201d9207.png";